import {Skeleton} from 'antd';
import get from 'lodash/get';
import isObject from 'lodash/isObject';
import PropTypes from 'prop-types';
import React, {useMemo} from 'react';
import {useQuery} from 'react-query';

const defaultRenderLoading = () => <div className="w-full flex justify-center">
  <Skeleton paragraph={false} active title={{className: 'm-0', width: '100%'}}/>
</div>;

export const createRenderRemoteEntity = (config = {}) => {
  
  const {
    service,
    render,
    keyPath = '_id',
    renderLoading = defaultRenderLoading,
    path = 'data',
    customMapFunc = (v) => v,
  } = config;
  
  const ItemComponent = ({keyRef}) => {
    const key = useMemo(() => isObject(keyRef) ? get(keyRef, keyPath) : keyRef, [keyRef]);
    
    const {data, isLoading} = useQuery(key, () => service(key), {refetchOnWindowFocus: false});
    
    const entity = useMemo(() => customMapFunc(get(data, path)), [data]);
    
    return isLoading ? renderLoading() : render(entity);
  };
  
  ItemComponent.propTypes = {
    keyRef: PropTypes.any
  };
  
  // eslint-disable-next-line react/display-name
  return (key) => <ItemComponent keyRef={key}/>;
};
